import React, { useEffect, useState } from 'react';
import axios from '../api/api'; // Đảm bảo đường dẫn đúng
import './Footer.css'; // Import CSS

const Footer = () => {
  const [policyLinks, setPolicyLinks] = useState([]); // Lưu các liên kết chính sách

  useEffect(() => {
    const fetchPolicyLinks = async () => {
      try {
        const response = await axios.get('/configurations/footer_policies');

        // Parse configValue nếu response.data có configValue
        if (response.data && response.data.configValue) {
          const parsedLinks = JSON.parse(response.data.configValue);
          setPolicyLinks(parsedLinks);
        } else {
          console.error('Unexpected data format:', response.data);
        }
      } catch (error) {
        console.error('Error fetching policy links:', error);
      }
    };

    fetchPolicyLinks();
  }, []);

  return (
    <footer className="bg-dark text-white py-4">
      <div className="container footer-container">
        {/* Khối thông tin công ty */}
        <div className="footer-info">
          <p><strong>CÔNG TY CỔ PHẦN ĐÀO TẠO VÀ TRUYỀN THÔNG TÂN TRÍ</strong></p>
          <p>Mã số doanh nghiệp: 2400763909</p>
          <p>Địa chỉ: Số nhà 03, ngõ 1009 đường Lê Lợi, Phường Dĩnh Kế, Thành phố Bắc Giang, Việt Nam</p>
          <p>
            Hotline: 0901508989 | Email:{' '}
            <a href="mailto:truyenthongtantri.edu@gmail.com" className="text-white">
              truyenthongtantri.edu@gmail.com
            </a>
          </p>
        </div>

        {/* Khối liên kết chính sách */}
        <div className="footer-links">
          <p><strong>Thông tin hỗ trợ</strong></p>
          <ul className="list-unstyled">
            {policyLinks.map((link, index) => (
              <li key={index}>
                <a href={link.url} className="text-white">
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Khối mã nhúng Bộ Công Thương */}
        <div className="footer-logo">
          <a href="http://online.gov.vn/Home/WebDetails/128210">
            <img
              alt="Bộ Công Thương"
              title="Đã thông báo với Bộ Công Thương"
              src="https://apiweb.tantriedu.vn/uploads/images/products/1737367057744-logoSaleNoti.png"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
